import { HttpClient } from '@angular/common/http';
import { AfterViewInit, Component, OnInit, Input } from '@angular/core';
import { CellEditingStoppedEvent, ICellRendererParams, ColDef, GridApi, IServerSideDatasource, IServerSideGetRowsParams } from 'ag-grid-community';
import { ObjectUnsubscribedError, Observable, catchError, filter, map, of } from 'rxjs';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { Router, ActivatedRoute } from '@angular/router';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { WarehouseAreaDetailsComponent } from '../warehouse-area-details/warehouse-area-details.component';
import { Position } from 'src/app/models/inventory-positions.model';
import { CsvExportModule } from 'ag-grid-community';
import { Package, Product } from 'src/app/models/inventory-positions.model';
import { faPersonWalkingDashedLineArrowRight } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'app-warehouse-positions',
  templateUrl: './warehouse-positions.component.html',
  styleUrls: ['./warehouse-positions.component.scss']
})
export class WarehousePositionsComponent {

  public gridReady = false;

  private gridApi!: GridApi;
  positions: Position[] = []
  public rowGroupPanelShow: "always" | "onlyWhenGrouping" | "never" = "always";
  uuid: string | null = ''
  selectedWarehouseCustomer: string | null = ''

  filteredCustomer: string = ''

  public themeClass: string = "ag-theme-ulaap";

  public detailCellRenderer: any = WarehouseAreaDetailsComponent
  public detailCellRendererParams: any;

  @Input() productFilter: string = '';

  constructor(private http: HttpClient, private route: ActivatedRoute, private dialog: MatDialog, private router: Router) { }

  ngOnInit(): void {

    this.route.paramMap.subscribe(params => {
      this.uuid = params.get('uuid');
    });

    this.updateGridData()

    // const url = `/api/inventory/inventory_warehouse_positions.php?uuid=${this.uuid}`
    // this.http.get(url).subscribe((response: any) => {
    //   if (response) {
    //     this.positions = response.data;
    //   }
    //   this.gridReady = true;
    // })

  }

  onGridReady(params: any) {
    this.gridApi = params.api;
    this.gridApi.sizeColumnsToFit();
  }


  defaultColDef = {
    sortable: true,
    filter: 'agTextColumnFilter',
    filterParams: {
      caseSensitive: false,
    },
    autoHeight: true,
    cellClass: 'cell-wrap-text',
    resizable: true,
    editable: true,
  };

  public autoGroupColumnDef: ColDef = {
    minWidth: 200,
  };

  public columnDefs: ColDef[] = [
    { field: 'inventory_position_uuid', headerName: 'Inventory Position UUID', hide: true },
    { field: 'inventory_position_name', headerName: 'Inventory Position Name', cellRenderer: 'agGroupCellRenderer', width: 60 },
    { field: 'row', headerName: 'Row', enableRowGroup: true, width: 20 },
    { field: 'section', headerName: 'Section', enableRowGroup: true, width: 20 },
    { field: 'level', headerName: 'Level', enableRowGroup: true, width: 20 },
    { field: 'spot', headerName: 'Spot', enableRowGroup: true, width: 20 },
    { field: 'packages', enableRowGroup: true, headerName: 'Spot Status', width: 30, valueFormatter: this.packagingTypeFormatter },
    { field: 'most_common_contact_organization', headerName: 'Contact Organization', enableRowGroup: true, width: 60 },
    { field: 'packaging_type', headerName: 'Type', width: 20 },
    {
      field: 'product_model',
      width: 40,
      headerName: 'Models',
      valueGetter: (params) => {
        if (!params.data) {
          return '';
        }
        // Ensure packages is defined and is an array
        if (!params.data.packages || !Array.isArray(params.data.packages) || params.data.packages.length === 0) {
          return '';
        }
  
        // Collect all product_model_number from each package's products
        const productModelNumbers = params.data.packages.reduce((pkgs: string[], pkg: any) => {
          if (pkg.products && Array.isArray(pkg.products) && pkg.products.length > 0) {
            pkgs.push(...pkg.products.map((prd: any) => prd.product_model_number));
          }
          else if(pkg.model && pkg.model !== null){
            pkgs.push(pkg.model);
          }
          return pkgs;
        }, []);
  
        // Join the product model numbers with a comma
        return productModelNumbers.join(', ');
      }
    },
    {
      field: 'product_serial',
      width: 40,
      headerName: 'Product Serial',
      valueGetter: (params) => {
        // Ensure packages is defined and is an array
        if (!params.data.packages || !Array.isArray(params.data.packages) || params.data.packages.length === 0) {
          return '';
        }

        // Collect all product_serial_number from each package's products
        const productSerialNumbers = params.data.packages.reduce((acc: string[], pkg: any) => {
          if (pkg.products && Array.isArray(pkg.products)) {
            acc.push(...pkg.products.map((prd: any) => prd.product_serial_number));
          }
          return acc;
        }, []);

        // Join the product model numbers with a comma
        return productSerialNumbers.join(', ');
      }
    },
    {
      field: 'pallet_serial',
      width: 40,
      headerName: 'Pallet Serial',
      valueGetter: (params) => {
        // Ensure packages is defined and is an array
        if (!params.data.packages || !Array.isArray(params.data.packages) || params.data.packages.length === 0) {
          return '';
        }

        // Collect all pallet_serial_number from each package's products
        const palletSerialNumbers = params.data.packages.reduce((acc: string[], pkg: any) => {
          if (pkg.products && Array.isArray(pkg.products)) {
            acc.push(...pkg.products.map((prd: any) => prd.pallet_serial_number));
          }
          return acc;
        }, []);

        // Join the product model numbers with a comma
        return palletSerialNumbers.join(', ');
      }
    }
  ]

  packagingTypeFormatter(params: any) {
    return Array.isArray(params.value) && params.value.length > 0 ? 'Occupied' : 'Empty';
  }

  updateGridData() {
    const url = `/api/inventory/inventory_warehouse_positions.php?uuid=${this.uuid}`
    this.http.get(url).subscribe((response: any) => {
      if (response) {
        this.positions = response.data;
        console.log(this.positions)
      }
      this.detailCellRendererParams = {
        positions: this.positions,
        uuid: this.uuid,
        updateGridData: this.updateGridData.bind(this) // Pass function for updating grid
      };
      this.gridReady = true;
    })

  }

  updateGridDataWithContact() {

    const url = `/api/inventory/inventory_warehouse_positions.php?uuid=${this.uuid}&contact_uuid=${this.selectedWarehouseCustomer}`
    this.http.get(url).subscribe((response: any) => {
      if (response) {
        this.positions = response.data;
      }
      this.gridReady = true;
    })

  }

  // for select customer dropdown, filter grid of active customer packages
  filterCustomer(customer: string) {
    if (this.gridApi) {
      if (customer == 'ALL CUSTOMERS') {
        this.filteredCustomer = '';
      }
      else {
        this.filteredCustomer = customer;
      }
      const filterModel = {
        most_common_contact_organization: { type: 'contains', filter: this.filteredCustomer },
      };
      this.gridApi.setFilterModel(filterModel);
    }
  }

  // for use of the search bars and filtering positions of the grid containing products
  filterProduct(product: string) {
    if (this.gridApi) {
        this.gridApi.setGridOption('quickFilterText', product)
    }
  }

  onBtnExport() {
    this.gridApi!.exportDataAsCsv();
  }

}
